import { IsOnboardingParams } from "@simplyk/common";
import { useSearchParams } from "next/navigation";

import { useCurrentUserContext } from "@/contexts/CurrentUserContext";

export const useIsOnboarding = () => {
  const { currentUser } = useCurrentUserContext();
  const searchParams = useSearchParams();
  const query = Object.fromEntries(searchParams?.entries?.() || []);
  const params: IsOnboardingParams = query;
  const isOnboarding = params.isOnboarding === "true" || Boolean(currentUser?.isGhostUser);

  return { isOnboarding };
};
